// react
import React from "react"
import { connect } from "react-redux"
// app
import Ratings from "components/person/Ratings"

import { getRatings, postRating, putRating, deleteRating } from "actions/profile/ratings/actions.js"


class Step3 extends React.Component {
    constructor(props) {
        super()

        const personid = props.personid

        this.onRatingAdd = rating => {
            rating.personid = personid
            this.props.postRating(rating)
        }
        this.onRatingEdit = rating => this.props.putRating(rating)
        this.onRatingRemove = id => this.props.deleteRating(id)
    }

    componentDidMount() {
        const personid = this.props.personid

        this.props.getRatings(personid)
    }

    render() {
        return (
            <Ratings
                data={ this.props.ratings }
                type={ this.props.type }
                onAdd={ this.onRatingAdd }
                onEdit={ this.onRatingEdit }
                onRemove={ this.onRatingRemove }
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        ratings: state.profile.ratings.get("data"),
        type: state.profile.person.get("data").get("type", "Pilot")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getRatings: personid => dispatch(getRatings(personid)),
        postRating: rating => dispatch(postRating(rating)),
        putRating: rating => dispatch(putRating(rating)),
        deleteRating: id => dispatch(deleteRating(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step3)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step3.js
 **/